import type { AnchorHTMLAttributes, ComponentType } from "react";
import { Link as WouterLink } from "wouter";
import { canonicalPath } from "@/lib/seo";

type CanonicalLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & { href: string };
const BaseLink = WouterLink as unknown as ComponentType<CanonicalLinkProps>;

/**
 * Keeps rendered internal navigation URLs aligned with the public directory
 * URLs served in production. File, telephone and external links are untouched.
 */
export function CanonicalLink({ href, ...props }: CanonicalLinkProps) {
  return <BaseLink {...props} href={canonicalPath(href)} />;
}